import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'profile-address',
  templateUrl: './profile-address.component.html',
  providers: []
})

export class ProfileAddressComponent {
  @Input() options: any;
  @Output() onViewProfile: EventEmitter<any> = new EventEmitter();

  constructor() {
  }

  openViewProfilePopup(data, key): void {
    data['key'] = key;
    this.onViewProfile.emit(data);
  }
}